import { Button, Card, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/context/AuthContext';
import { canWriteFlotas } from '@/layouts/navigation';
import { FleetTable } from '../components/FleetTable';
import { useFleets } from '../hooks/useFleets';

/**
 * Listado de Flotas (US-2.3, `/flotas`) — paginación server-side vía `useFleets`.
 *
 * RBAC (espejo del contrato): lectura y escritura solo para `SUPER_ADMIN`/`SOPORTE_N3`.
 * Las flotas son cuentas de plataforma xGoE (tipo FLOTA) sin aliado propietario,
 * así que no hay filtro por aliado.
 */
export function FleetsListPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const fleets = useFleets();
  const canCreate = canWriteFlotas(user?.role);

  const goToCreate = () => navigate('/flotas/nuevo');
  const goToDetail = (fleetId: string) => navigate(`/flotas/${encodeURIComponent(fleetId)}`);

  return (
    <div className="flotas-page">
      <div className="flotas-page__header">
        <Typography.Title level={3} style={{ margin: 0 }}>
          Flotas
        </Typography.Title>
        {canCreate && (
          <Button type="primary" icon={<PlusOutlined />} onClick={goToCreate}>
            Nueva flota
          </Button>
        )}
      </div>

      <Card>
        <FleetTable
          fleets={fleets.data}
          meta={fleets.meta}
          loading={fleets.loading}
          error={fleets.error}
          filters={fleets.filters}
          canCreate={canCreate}
          onFiltersChange={fleets.setFilters}
          onOffsetChange={fleets.setOffset}
          onRetry={fleets.refresh}
          onCreate={goToCreate}
          onSelect={goToDetail}
        />
      </Card>
    </div>
  );
}
